import BlockHeightTask from './index';

export default { path: '/home/blockHeightTask', component: BlockHeightTask };
